import { createStyles, makeStyles, Theme } from '@material-ui/core/styles'
import { color } from 'src/color/color'

// TODO: somehow breakpoints are sets to material-ui
// default values when trying to use theme ones,
// further investigation is required
const mdBreakpoint = '@media (max-width: 991px)'

export const useStyles = makeStyles((theme: Theme) => createStyles({
  container: {
    [mdBreakpoint]: {
      padding: theme.spacing(0, 2),
    },
  },
  logo: {
    display: 'block',
    maxHeight: '3rem',
    height: '100%',
    [mdBreakpoint]: {
      maxHeight: '2.4rem',
    },
  },
  section: {
    display: 'flex',
    padding: theme.spacing(3.125, 0),
    alignItems: 'center',
    background: color('white'),
    [mdBreakpoint]: {
      padding: theme.spacing(2.25, 0),
    },
  },
}))
